<main class="app-content">
  BAhut BAdi error hai
  <div class="page-error tile">
    <h1><i class="fa fa-exclamation-circle"></i> Error {{this.statusCode}}: {{this.errorMsg}}</h1>
    <p>{{this.errorDesc}}</p>
    <p><a routerLink="/" class="btn btn-primary">Go Back Home</a></p>
  </div>
</main>